import useSWRImmutable from 'swr/immutable';
import baseFetcher from '../../shared/baseFetcher';

const useVehicleMakes = (options) => useSWRImmutable(
  { url: '/prequals/repairs/vehicle-makes' },
  baseFetcher,
  {
    suspense: true,
    ...options,
  },
);

export default useVehicleMakes;
